import styled, { keyframes } from 'styled-components';
import Theme from '../../style/theme';
import { AARContainer } from '@tqwi/aarc';
import VoteImage from '../../assets/images/audience.png';
import { useEffect, useState, useRef } from 'react';

export const Video = () => {


	useEffect(() => {
		document.addEventListener('voting_finished', onVotingFinished);
		document.addEventListener('start-timer', startTimer);
		document.addEventListener('state_continue', () => setBottomContainerActive(false));
		
		return () => {
			document.removeEventListener('voting_finished', onVotingFinished);
			document.removeEventListener('start-timer', startTimer);
			document.removeEventListener('state_continue', () => setBottomContainerActive(false));
		};
	}, []);

	const defaultTime = 15;
	const [timeRemaining, setTimeRemaining] = useState(15);
	const [isTimerActive, setIsTimerActive] = useState(false);
	const [votingDone, setVotingDone] = useState(false);
	const [bottomContainerActive, setBottomContainerActive] = useState(false);

	const timeoutRef = useRef(null);

	// Count down one second per render while the timer is active. Stopping the
	// timer (voting finished early) clears the pending tick, so the countdown
	// can't keep running invisibly and fire timer_end during the outcome video.
	useEffect(() => {
		if (!isTimerActive) return;

		if (timeRemaining <= 0) {
			setIsTimerActive(false);
			onTimerEnd();
			return;
		}

		const tick = setTimeout(() => {
			setTimeRemaining(time => time - 1);
		}, 1000);

		return () => clearTimeout(tick);
	}, [isTimerActive, timeRemaining]);

	useEffect(() => {
		if(!votingDone) return;
		if(timeoutRef.current) {
			clearTimeout(timeoutRef.current);
			timeoutRef.current = null;
		}
		setIsTimerActive(false);
	}, [votingDone]);

	const startTimer = () => {
		setVotingDone(false);
		setBottomContainerActive(true);
		setTimeRemaining(defaultTime);
		if(timeoutRef.current) {
			clearTimeout(timeoutRef.current);
			timeoutRef.current = null;
		}
		timeoutRef.current = setTimeout(() => {
			setIsTimerActive(true);
		}, 6000);
	};

	const onTimerEnd = () => {
		document.dispatchEvent(new CustomEvent('timer_end', {
			detail: {},
		}));
	};

	const onVotingFinished = () => {
		setVotingDone(true);
	};

	const decisions = [
		{ id: 1, text: 'Antwoord' },
		{ id: 2, text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Provident.' },
		{ id: 3, text: 'Antwoord' },
		{ id: 4, text: 'Antwoord' }
	];

	return (
		<Container id={'video'} className="d-none">

			<Embed 
				id="embed" 
				src="https://player.vimeo.com/video/558037627?background=1&loop=0&autoplay=0&muted=false" 
				allow="autoplay" 
				frameBorder="0" 
				webkitallowfullscreen='true' 
				mozallowfullscreen='true' 
				allowFullScreen
			/>

			<AnswerCounter id="" style={{opacity: isTimerActive ? 1 : 0}}>
				<AnswerCounterIcon/> 
				<span id="host-answercounter">NA</span>
			</AnswerCounter>

			<BottomContainer id="host-decisions" visible={bottomContainerActive}>
				<AARContainer 
					$fitparent
					$verticalalignment='top'
					$horizontalalignment='center'
					$innerstyle={{display: 'flex', flexDirection: 'column'}}
					$originalresolution={[1920,1080]}
					$aspectratio='4/1'
					$fontSize={90}
				>
					<Timer id="timer" style={{opacity: isTimerActive ? 1 : 0}}>
						<TimerBackdrop/>
						<TimerFill id="timer-bar-fill" timeRemaining={timeRemaining} defaultTime={defaultTime}/>
						<Countdown timeRemaining={timeRemaining}>{timeRemaining}</Countdown>
					</Timer>
					{votingDone && <PressSpaceToContinue>Druk op de spatiebalk om door te gaan</PressSpaceToContinue>}
					<Decisions>
						{decisions.map((decision, index) => (
							<Decision key={decision.id} id={`host-decision-${decision.id}`} delay={index + 1} animate={ bottomContainerActive? true : false}>
								<Indexing>{decision.id}. </Indexing>
								<span id={`decision-${decision.id}`}>{decision.text}</span>
								<Votes id={`stemmen-${decision.id}`} style={{opacity: votingDone ? 1 : 0}}>00</Votes>
							</Decision>
						))}
					</Decisions>
				</AARContainer>
			</BottomContainer>

			{/* the video cover prevents users from selecting the iframe, which in turn disabled our input logic */}
			<VideoCover/> 
		</Container>
	);
};

// styled components

const Container = styled.div`
	position: absolute;
	inset:0;
    width: 100%;
    height: 100%;

    background-color: black;

    overflow: hidden;

	z-index: 2;
`;

const slideInBottom = keyframes`
	0%{
		translate: 0 20%;
	}
	100%{
		translate: 0 0;
	}
`;

const BottomContainer = styled.div`
	padding-inline: 5%;
	padding-block: 0;

	display: flex;
	flex-direction: column;

	background-color: black;

	position: absolute;
    width: 100%;
    height: 40%;
    bottom: 0;

	opacity: ${e => e.visible ? 1 : 0};

	animation: ${e => e.visible ? slideInBottom : null} 1s forwards ease-in-out;
`;

const AnswerCounterIcon = styled.div`
	background-image: url(${VoteImage});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
	height: 1em;
	aspect-ratio: 1/1;
`;		

const Embed = styled.iframe`
    height: 100%;
    width: 100%;
`;

const AnswerCounter = styled.div`
	position: absolute;
    background-color: grey;

    text-transform: uppercase;
    font-family: 'Graphik';
    color: white;

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center; 

	right:0;
    top: 100px;
	font-size: 3em;

	padding-inline: .25em;
	padding-block: .15em;

	transition: opacity 1s ease-in-out;
`;

const VideoCover = styled.div`
	position: absolute;
    width: 100%;
    height: 100%;
    left:0;
    top:0;
`;

const slideIn = keyframes`
	0% {
		translate: -10% 0;
		opacity: 0;
	}
	100%{
		translate: 0 0;
		opacity: 1;
	}
`;

const Decisions = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: 1fr 1fr;
	column-gap: .2em;
	font-family: 'Graphik';
	color: ${Theme.colors.neutralLightest};

	flex-grow: 1;

	position: relative;
`;

const Decision = styled.div`
	display: flex;
	align-items: center;
	gap: 0.2em;
	animation: 1s ${e => e.animate ? slideIn : null} forwards ease-out;
	animation-delay: ${e => e.delay}s;

	opacity: 0;

	transition: opacity .5s ease-in-out;

	white-space: nowrap;
`;

const Votes = styled.span`
	margin-left: auto;
	background-color: ${Theme.colors.neutralDarker};
	padding: 0 0.1em;
`;

const Indexing = styled.span`
	color: ${Theme.colors.primary};
`;


const timerBorderWidth = 0.25;
const Timer = styled.div`
	height: 17.5%;
	width: 100%;
	position: relative;
	translate: 0 -50%;
	border-radius: 100em;

	transition: opacity 1s ease-in-out;
`;

const TimerBackdrop = styled.div`
	position: absolute;
	inset: 0;
	background-color: gray;
	border-radius: 100em;
	border: ${timerBorderWidth}em solid ${Theme.colors.neutralLightest};
`;

const TimerFill = styled.div`
	position: absolute;
	inset-block:${timerBorderWidth}em;
	inset-inline-end:${timerBorderWidth}em;
	background-color: ${Theme.colors.primary};
	border-radius: 100em;
	width: calc(${(e) => (e.timeRemaining / e.defaultTime) * 100}% - ${timerBorderWidth * 2}em);
	transition: width 1.5s linear;
`;

const timerHeight = 175;
const Countdown = styled.div`
	position: absolute;
	right:0;
	top:-${timerHeight * 0.25}%;

	height: ${timerHeight}%;
	aspect-ratio: 1/1;

	background-color: white;
	color: ${(e) => e.timeRemaining < 6 ? Theme.colors.primary : 'black'};
	border-radius: 100%;

	display: flex;
	justify-content: center;
	align-items: center;

	font-size: 1em;
	font-family: 'Graphik';

	padding-block-end: .25%;
`;

const flashing = keyframes`
	0%{
		opacity: 0;
	}
	50%{
		opacity: 1;
	}
	100%{
		opacity: 0;
	}
`;

const PressSpaceToContinue = styled.div`
	position: absolute;
	top:0;inset-inline:0;
	height: 17.5%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	/* font-family: 'Graphik'; */
	font-size: 0.5em;
	opacity: 0;
	animation: ${slideIn} 1s forwards;
	animation-delay: 6s;
`;